module.exports = __webpack_public_path__ + "img/acount_des_4.07af2c37.jpg";